<template>
  <base-panel class="tw-flex-col" full-width no-padding no-margin>
    <template #header>
      <panel-header anchor-id="guide" low-weight :text="$t('guide')" />
    </template>

    <loading-content v-if="panelLoading" hide-title></loading-content>

    <base-description v-else :content="text" />
  </base-panel>
</template>

<script>
import LoadingContent from '@components/Loading/LoadingContent.vue'
import PanelHeader from '@components/PanelHeader.vue'

export default {
  components: {
    LoadingContent,
    PanelHeader,
  },
  props: {
    text: {
      type: String,
      default: null,
    },
    panelLoading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
